// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/admin.scss
// module id = 79
// module chunks = 0